import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { previewSchemePdf,
// 验证工资条姓名是否可用
getTypeAndTaxList as _getTypeAndTaxList,
// 获取结算类型
getSchemeListBySubId as _getSchemeListBySubId,
// 获取工资条模板list
getAllColumns,
// 无模版id 获取模版详情
getSchemeInfo,
// 有模版id 获取模版详情
getSendAllColumns,
// 获取子项目的 scheme
addscheme,
// 新建工资条模板
editScheme,
// 保存编辑工资条模板
sendPayslip,
// 发送工资条
sentPayslipSetting as _sentPayslipSetting // 查看设置工资条
} from '@/api/payroll/pay-slip';
import { infoData } from './config.js';
// App端预览组件
import preview from '@/components/mobile-preview';
export default {
  components: {
    preview: preview
  },
  data: function data() {
    return {
      query: {},
      params: {},
      payrollSchemeId: '',
      infoData: {},
      formData: {},
      formRules: {},
      formLabel: {},
      selectData: {},
      payList: [],
      // 自定义方案列表
      cPayList: [],
      // 自定义方案列表
      schemeList: [],
      visible: false,
      visible1: false,
      islist: false,
      isitem: false,
      pdfLoading: false,
      saveLoading: false,
      sendLoading: false,
      isUpdate: false,
      payShow: '',
      schemeIndex: -1,
      cSchemeIndex: 0,
      schemeItem: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() + 3600 * 1000 * 24 * 10 || time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
      }
    };
  },
  watch: {
    // 监听路由变化，统一处理首次加载和路由更新
    $route: {
      immediate: true,
      deep: true,
      handler: function handler(to) {
        // 更新 query 和 params
        this.query = _objectSpread({}, to.query);
        this.params = _objectSpread({}, to.params);
        // 更新依赖 state 的值
        var newState = to.query.state;
        this.payrollSchemeId = to.query.payroll_scheme_id;
        this.infoData = infoData[newState];
        this.formData = infoData[newState].formData;
        this.formRules = infoData[newState].formRules;
        this.formLabel = infoData[newState].formLabel;
        this.visible = +newState === 3;
        // 执行初始化逻辑
        this.getRouterParams();
        if ([1, 2].includes(+newState)) this.getTypeAndTaxList();
      }
    },
    'formData.send_time': {
      deep: true,
      handler: function handler(newValue, oldValue) {
        if (newValue && this.query.state === '3') {
          var time = new Date(newValue).getTime();
          var date = new Date().getTime() + 60 * 1000 * 30;
          var nowDate = moment(date).format('yyyy-MM-DD HH:mm:ss');
          var dt = nowDate.split(' ');
          var st = '';
          if (newValue.split(' ')[0] === dt[0] && time < date) {
            // 是今天,选择 的时间开始为此刻的时分秒
            st = dt[1];
          } else if (newValue.split(' ')[0] !== oldValue.split(' ')[0]) {
            // 明天及以后从0时开始
            st = '00:00:00';
          } else {
            st = newValue.split(' ')[1];
          }
          this.formData.send_time = newValue.split(' ')[0] + ' ' + st;
        }
      }
    }
  },
  methods: {
    handlerBack: function handlerBack() {
      var query = {
        active: this.query.active
      };
      if (this.query.month2) query.month2 = this.query.month2;
      if (this.query.month3) query.month3 = this.query.month3;
      this.$router.push({
        path: '/payroll/pay-slip',
        query: query
      });
    },
    getRouterParams: function getRouterParams() {
      // 路由参数获取
      // scheme_id：工资条id  subProjectId：子项目id
      var _this$params = this.params,
        schemeId = _this$params.schemeId,
        subProjectId = _this$params.subProjectId;
      var _this$query = this.query,
        type = _this$query.type,
        tax_deduction_status = _this$query.tax_deduction_status;
      this.formData.name = '';
      this.formData.type = Number(type) || '';
      this.formData.tax_deduction_status = Number(tax_deduction_status) || '';
      // 待发工资条-->去发工资条-->创建模板
      if (+this.query.state === 1) this.handlerChangeType();else if (+this.query.state === 2) this.handlerGetSchemeInfo(schemeId);else if (+this.query.state === 3) {
        this.formData.send_way = [];
        this.formData.send_time_type = '';
        this.formData.send_time = '';
        this.formData.status = '';
        this.formData.is_cover = false;
        this.getSchemeListBySubId(subProjectId);
      } else if (this.query.state === '4') this.sentPayslipSetting(subProjectId);
    },
    sentPayslipSetting: function sentPayslipSetting(id) {
      var _this = this;
      // state:4 编辑工资条模板调用详情数据
      _sentPayslipSetting({
        payslip_id: id
      }).then(function (res) {
        if (res && res.code === 1) {
          _this.formData = res.data;
          _this.formData.type = _this.query.type;
          _this.formData.tax_deduction_status = _this.query.tax_deduction_status;
          _this.handleDetail(res.data.scheme);
        }
      });
    },
    confirmScheme: function confirmScheme(state) {
      var _this2 = this;
      // state:3 确认工资条选择模版 取消关闭弹窗则默认不使用模板
      if (state) {
        this.schemeIndex = this.schemeIndex === -1 ? this.cSchemeIndex : this.schemeIndex;
        this.cSchemeIndex = this.schemeIndex;
        this.isUpdate = false; // 修改模板 更新模板不展示
      } else this.schemeIndex = this.cSchemeIndex;
      this.schemeItem = this.schemeList[this.schemeIndex];
      this.visible = false;
      getSendAllColumns({
        is_batch: this.$route.query.merge ? '1' : '',
        sub_project_id: this.params.subProjectId,
        scheme_id: this.schemeItem.scheme_id
      }).then(function (res) {
        if (res && res.code === 1) {
          _this2.formData.is_cover = res.data.is_cover;
          _this2.handleDetail(res.data.scheme);
        }
      });
    },
    handlerGetSchemeInfo: function handlerGetSchemeInfo(id) {
      var _this3 = this;
      //  state:2 编辑工资条模板调用详情数据
      this.formData.payslip_scheme_id = id;
      getSchemeInfo({
        payslip_scheme_id: id
      }).then(function (res) {
        if (res && res.code === 1) {
          _this3.formData.type = _this3.query.state !== '3' ? Number(res.data.settlement_type) : ''; // 结算类型
          _this3.formData.name = _this3.query.state !== '3' ? res.data.name : ''; // 工资条名称
          _this3.formData.tax_deduction_status = _this3.query.state !== '3' ? Number(res.data.tax_deduction_status) : ''; // 税
          _this3.handleDetail(res.data.items);
        }
      });
    },
    handlerChangeType: function handlerChangeType() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this4$formData, type, tax_deduction_status, params, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //  state:1 创建时无ID，获取结算类型关联展示项
              _this4.payList = [];
              _this4$formData = _this4.formData, type = _this4$formData.type, tax_deduction_status = _this4$formData.tax_deduction_status;
              params = {
                settlement_type: type,
                tax_deduction_status: tax_deduction_status
              };
              if (params.settlement_type && params.tax_deduction_status) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return getAllColumns(params);
            case 7:
              res = _context.sent;
              if (res && res.code === 1) {
                _this4.handleDetail(res.data);
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 处理获取的详情数据
    handleDetail: function handleDetail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var payList = [];
      var keys = Object.keys(data || {});
      if (keys.length === 0) {
        this.payList = payList;
        return;
      }
      keys.forEach(function (item, index) {
        data[item].is_selected = !!data[item].is_selected;
        if (data[item].columns) {
          // columns中的复选框状态
          data[item].columns.forEach(function (column) {
            column.is_selected = !!column.is_selected;
          });
        }
        payList[data[item].sort] = {
          column: data[item].column,
          is_selected: data[item].is_selected,
          sort: data[item].sort,
          txt: data[item].txt,
          isIndeterminate: false,
          key: item,
          show: false,
          columns: data[item].columns
        };
        // 判断复选框状态
        if (payList[index]) {
          if (data[item].columns) {
            payList[index].isIndeterminate = data[item].columns.some(function (column) {
              return column.is_selected;
            });
          }
          if (payList[index].is_selected) payList[index].isIndeterminate = false;
        }
      });
      payList = payList.filter(function (item) {
        return item;
      });
      this.payList = payList;
    },
    goToDetail: function goToDetail() {
      // 创建工资条模板
      this.$router.push({
        path: '/payroll/edit-pay-slip',
        query: _objectSpread(_objectSpread({}, this.query), {}, {
          state: 1
        })
      });
    },
    handlerName: function handlerName(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              e.target.value = String(e.target.value).trim();
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 是否展示薪资项
    onShow: function onShow(value) {
      if (!value.show) {
        this.payList.forEach(function (item) {
          item.show = false;
        });
      }
      value.show = !value.show;
    },
    // 全选
    handleCheckAllChange: function handleCheckAllChange(val, item) {
      item.isIndeterminate = false;
      if (item.columns) {
        item.columns.forEach(function (column) {
          column.is_selected = val;
        });
      }
      this.isUpdate = true;
    },
    // 点击复选框控制父元素展示
    handleCheckChange: function handleCheckChange(item) {
      var state = item.columns.every(function (column) {
        return column.is_selected;
      });
      var state1 = item.columns.every(function (column) {
        return !column.is_selected;
      });
      item.is_selected = state;
      item.isIndeterminate = state ? false : !state1;
      this.isUpdate = true;
    },
    // 保存工资条模板
    savePaysilp: function savePaysilp() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.$refs.form.validate( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(valid) {
                  var query, res;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!valid) {
                          _context3.next = 16;
                          break;
                        }
                        _this5.saveLoading = true;
                        query = {
                          name: _this5.formData.name,
                          settlement_type: _this5.formData.type,
                          tax_deduction_status: _this5.formData.tax_deduction_status,
                          scheme: _this5.handData(_this5.payList)
                        };
                        res = {};
                        if (!_this5.query.payslip_scheme_id) {
                          _context3.next = 11;
                          break;
                        }
                        query.payslip_id = _this5.query.payslip_scheme_id;
                        _context3.next = 8;
                        return editScheme(query);
                      case 8:
                        res = _context3.sent;
                        _context3.next = 14;
                        break;
                      case 11:
                        _context3.next = 13;
                        return addscheme(query);
                      case 13:
                        res = _context3.sent;
                      case 14:
                        _this5.saveLoading = false;
                        if (res && res.code === 1) {
                          _this5.$message.success(res.message);
                          _this5.handlerBack();
                        }
                      case 16:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handleUpdate: function handleUpdate() {
      var _this6 = this;
      // 更新模板
      var state = this.payList.filter(function (item) {
        return item.is_selected || item.isIndeterminate;
      });
      if (!state.length) {
        this.$message.warning(this.$t('pay_slip_54'));
        return;
      }
      this.$confirm(this.$t('pay_slip_51'), this.$t('pay_slip_50'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        var query = {
          name: _this6.schemeItem.name,
          settlement_type: _this6.query.type,
          tax_deduction_status: _this6.query.tax_deduction_status,
          scheme: _this6.handData(_this6.payList),
          payslip_id: _this6.schemeItem.scheme_id
        };
        editScheme(query).then(function (res) {
          if (res && res.code === 1) _this6.$message.success(res.message);
        });
      }).catch(function () {});
    },
    closeSend: function closeSend() {
      this.visible1 = false;
      this.$refs.sendForm.resetFields();
    },
    confirmSend: function confirmSend() {
      var _this7 = this;
      // 确认发送
      this.$refs.sendForm.validate(function (valid) {
        if (valid) {
          var query = {
            is_batch: _this7.$route.query.merge ? '1' : '',
            sub_project_id: _this7.params.subProjectId,
            name: _this7.formData.name,
            send_way: _this7.formData.send_way.join(','),
            send_time_type: _this7.formData.send_time_type,
            send_time: _this7.formData.send_time,
            status: _this7.formData.status ? '1' : '0',
            scheme: _this7.handData(_this7.payList),
            scheme_id: _this7.schemeItem.scheme_id
          };
          _this7.sendLoading = true;
          sendPayslip(query).then(function (res) {
            if (res && res.code === 1) {
              _this7.closeSend();
              // 批量发送 跳转到已发工资条
              if (_this7.$route.query.merge) {
                _this7.$router.push({
                  path: '/payroll/pay-slip',
                  query: {
                    active: '3',
                    month3: _this7.$route.query.month2
                  }
                });
                return;
              }
              // 其他跳转结果页面
              _this7.$router.push({
                path: '/payroll/pay-send-results/' + res.data.payslip_id,
                query: _objectSpread({}, _this7.$route.query)
              });
              _this7.$message.success(_this7.$t('pay_slip_53'));
            }
          }).finally(function () {
            _this7.sendLoading = false;
          });
        }
      });
    },
    sendPaysilp: function sendPaysilp() {
      var _this8 = this;
      // 选择发送方式
      var state = this.payList.filter(function (item) {
        return item.is_selected || item.isIndeterminate;
      });
      if (!state.length) {
        this.$message.warning(this.$t('pay_slip_54'));
        return;
      }
      this.$refs.form.validate(function (valid) {
        if (valid) _this8.visible1 = true;
      });
    },
    pdfView: function pdfView() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // PDF预览
              if (_this9.$refs.form) {
                _this9.$refs.form.validate(function (valid) {
                  if (valid) _this9.handlePdf();
                });
              } else {
                _this9.handlePdf();
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handlePdf: function handlePdf() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var params;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this10.pdfLoading = true;
              params = {
                name: _this10.formData.name,
                settlement_type: _this10.formData.type,
                tax_deduction_status: _this10.formData.tax_deduction_status,
                scheme: _this10.handData(_this10.payList)
              };
              previewSchemePdf(params).then(function (res) {
                if (res && res.code === 1) window.open(res.data, '_blank');
              }).finally(function () {
                _this10.pdfLoading = false;
              });
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getTypeAndTaxList: function getTypeAndTaxList() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // 获取结算类型
              _getTypeAndTaxList().then(function (res) {
                if (res && res.code && res.code === 1) _this11.selectData = res.data;
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handData: function handData(data) {
      // 处理最后需要返回后端的数据
      var scheme = {};
      data.forEach(function (item) {
        var val = JSON.parse(JSON.stringify(item));
        scheme[item.key] = val;
        val.is_selected = val.is_selected ? 1 : 0;
        delete val.isIndeterminate;
        delete val.key;
        delete val.show;
        if (val.columns) {
          val.columns.forEach(function (column) {
            column.is_selected = column.is_selected ? 1 : 0;
          });
        }
      });
      return scheme;
    },
    onMouseenter: function onMouseenter(val) {
      // 移入可以拖拽
      this['is' + val] = true;
    },
    onMouseleave: function onMouseleave(val) {
      // 移除关闭拖拽
      this['is' + val] = false;
    },
    handlerDragstart: function handlerDragstart(event, index, str, data) {
      // 拖拽
      this.payShow = '';
      if (data) this.handle(data);
      event.dataTransfer.setData(str, index);
    },
    handle: function handle(data) {
      var _this12 = this;
      data.forEach(function (item) {
        if (item.show) {
          _this12.payShow = item.key;
          item.show = false;
        }
      });
    },
    handlerDrop: function handlerDrop(event, index, data, str, state) {
      // 拖拽
      this.isUpdate = true;
      event.preventDefault();
      // 获取被拖拽元素传递的索引
      var targetIndex = Number(event.dataTransfer.getData(str));
      // 更换位置的数据
      if (this.isitem && str === 'column' || this.islist && str === 'columns') {
        var coverData = data.splice(targetIndex, 1)[0];
        if (state && this.showIdnex !== -1) coverData.show = true;
        data.splice(index, 0, coverData);
      }
    },
    handlerDragend: function handlerDragend(data, type) {
      var _this13 = this;
      // 拖拽
      data.forEach(function (item, index) {
        item.sort = index;
        if (type === 'columns') item.show = item.key === _this13.payShow;
      });
    },
    getSchemeListBySubId: function getSchemeListBySubId(subProjectId) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var res;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _getSchemeListBySubId({
                sub_project_id: subProjectId,
                is_batch: _this14.$route.query.merge ? '1' : ''
              });
            case 2:
              res = _context8.sent;
              if (res && res.code === 1) {
                res.data.push({
                  scheme_id: '0',
                  name: _this14.$t('pay_slip_37'),
                  name_key: ''
                });
                _this14.schemeList = res.data;
                _this14.cSchemeIndex = _this14.schemeList.length - 1;
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  }
};